import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Loader2, Webhook } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

export const StripeSetup = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/stripe/status").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => {
    load();
  }, []);
  const connect = async () => {
    setBusy(true);
    try {
      await api.post("/admin/stripe/webhook/setup", { origin_url: window.location.origin });
      toast.success("Stripe webhook connected");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  if (!s) return null;
  return (
    <div className="mt-3 flex flex-col gap-2 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm md:flex-row md:items-center md:justify-between" data-testid="stripe-setup">
      <p className="flex items-center gap-2">
        <Webhook className="h-4 w-4 text-blue-700" />
        Stripe ({s.mode === "none" ? "no key" : `${s.mode} mode`}):{" "}
        {s.webhook_ready ? <span className="flex items-center gap-1 font-semibold text-emerald-700" data-testid="stripe-webhook-ready"><CheckCircle2 className="h-4 w-4" /> webhook connected</span>
          : <span className="font-semibold text-amber-700" data-testid="stripe-webhook-missing">webhook not connected; monthly auto-pay charges won't be recorded</span>}
      </p>
      <Button size="sm" variant="outline" onClick={connect} disabled={busy || s.mode === "none"} data-testid="stripe-webhook-connect-btn">
        {busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}{s.webhook_ready ? "Reconnect" : "Connect webhook automatically"}
      </Button>
    </div>
  );
};
